document.addEventListener('DOMContentLoaded', function() {

    const sections = document.querySelectorAll('.cust-main-blog');
    
    sections.forEach(section => {
        // Use event delegation: Listen to entire section for click events
        section.addEventListener('click', function(e) {
            // Check if clicked element is show-btn
            if (e.target.closest('.show-btn')) {
                const showBtn = e.target.closest('.show-btn');
                const item = showBtn.closest('.cust-article-item');
                const hiddenTags = item.querySelectorAll('.cust-article-item__tag.hide');
                
                hiddenTags.forEach(function(tag) {
                    tag.classList.remove('hide');
                });
                showBtn.classList.add('hide');
            }
        });

        // fixed button list nav logic

        const header = document.querySelector('.shopify-section-header');
        const announcementBar = document.querySelector('.shopify-section-cust-announcement-bar');

        function updateSectionFixed() {
            const headerHeight = header ? header.offsetHeight : 0;
            const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
            const totalHeight = headerHeight + announcementHeight;

            const sectionTop = section.getBoundingClientRect().top;

            if (sectionTop <= totalHeight) {
                section.classList.add('fixed');
            } else {
                section.classList.remove('fixed');
            }
        }

        window.addEventListener('scroll', updateSectionFixed);

        updateSectionFixed();

        // Show Sort list logic
        const sortMain = section.querySelector('.cmb-content__sort');
        if (sortMain) {
            const sortToggleBtn = sortMain.querySelector('.cmb-content-sort-result__text');
            const sortItems = sortMain.querySelectorAll('.cmb-content-sort__item');
    
            if (!sortToggleBtn) return;

            sortToggleBtn.addEventListener('click', function() {
                sortMain.toggleAttribute('open');
            });
    
            sortItems.forEach(item => {
                item.addEventListener('click', function () {
                    sortItems.forEach(i => i.classList.remove('active'));
    
                    this.classList.add('active');
    
                    const toggleSpan = sortToggleBtn.querySelector('span');
                    if(toggleSpan) {
                        toggleSpan.textContent = this.textContent.trim();
                    }
    
                    sortMain.removeAttribute('open');
                });
            });
        }

        // Filter popup logic
        const filterBtns = section.querySelectorAll('.cmb-content-filter__btn');
        const filterPopup = section.querySelector('.cmb-content-filter__popup');
        if (!filterPopup) return;
        
        const filterCloseBtn = filterPopup.querySelector('.cmb-filter__close');

        filterBtns.forEach(filterBtn => {
            filterBtn.addEventListener('click', function() {
                filterPopup.toggleAttribute('open');
            });
        });

        if (filterCloseBtn) {
            filterCloseBtn.addEventListener('click', function() {
                filterPopup.removeAttribute('open');
            });
        }

        filterPopup.addEventListener('click', function(e) {

            const main = filterPopup.querySelector('.cmb-filter__main');

            if (main && !main.contains(e.target)) {
                filterPopup.removeAttribute('open');
            }
        });

        // Show filter popup accordion logic
        const accordions = section.querySelectorAll('.cmb-filter-accordion__item');
        accordions.forEach(accordion => {
            const head = accordion.querySelector('.cmb-filter-accordion-item__head');

            if(head) {
                head.addEventListener('click', function() {
                    accordion.toggleAttribute('open');
                });
            }
        });

        // Filter function relate logic
        const checkboxes = section.querySelectorAll('.cmb-filter-accordion-item__checkbox input[type="checkbox"]');
        const deleteBtns = section.querySelectorAll('.cmb-current-filter__tag');

        const applyBtn = section.querySelector('.cmb-filter__apply');
        const clearBtn = section.querySelector('.cmb-filter__clear');

        if (!applyBtn || !checkboxes.length) return;

        const baseUrl = applyBtn.getAttribute('href').replace(/\/$/, '');
        const tagRouter = 'tagged/'
        const view = '?view=new-blog';

        function updateApplyLink() {
            const selectedTags = [];

            checkboxes.forEach(cb => {
            if (cb.checked) {
                selectedTags.push(cb.value.toLowerCase().replace(/\s+/g, '-'));
            }
            });

            if (selectedTags.length > 0) {
            applyBtn.href = `${baseUrl}/${tagRouter}${selectedTags.join('+')}${view}`;
            } else {
            applyBtn.href = `${baseUrl}${view}`;
            }
        }

        deleteBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                btn.classList.add('hidden');
                const val = btn.getAttribute('data-del-value');
                const input = section.querySelector(`input#${val}`);
                if (input) {
                    input.checked = false;
                }

                updateApplyLink();
            });
        })

        function updateCheckbox () {
            deleteBtns.forEach(btn => {
                const val = btn.getAttribute('data-del-value');
                const input = section.querySelector(`input#${val}`);
                if (input) {
                    input.checked = true;
                }
            })
        }

        function removeFilterTags() {
            deleteBtns.forEach(btn => {
                btn.classList.add('hidden');
                const val = btn.getAttribute('data-del-value');
                const input = section.querySelector(`input#${val}`);
                
                if (input) {
                    input.checked = false;
                }

            });
            window.location.href = `${baseUrl}${view}`;
        }

        checkboxes.forEach(cb => {
            cb.addEventListener('change', updateApplyLink);
        });

        if (clearBtn) {
            clearBtn.addEventListener('click', () => {
                removeFilterTags();
            });
        }

        updateApplyLink();

        updateCheckbox ();

    })

});